
(function() {
  angular.module('ngClick', function($location) {
    return {
      link: function(scope, elem, attrs) {
        if (attrs.href) {
          elem.on('touchend', function() {
            $location.path(attrs.href);
          });
        }
      },
      priority: 1
    };
  });



  app.controller('productCtr', ['$scope','$sce', function($scope, $sce) {
    window.onload = function() {
      var subFrom = document.querySelector('.product-subtocart');
      if (subFrom == null) {
        $('.purchase-type').remove();
      }
    }




    
    var llRewardPointMath = ll_rule;


    
    tippy('.product_offer_note', {
      content: "<p style='font-size:0.8rem;z-index:99;'>To claim your free pack simply add it to a Jointace Max order once you get to the shipping page of the checkout. <b>UK orders only.</b><small> <a style='color:white;' href='https://www.vitabiotics.com/pages/terms'>Ts&Cs apply</a></small></p>",
      maxWidth: '280px',
      interactive: true,
      allowHTML: true,
      trigger: 'click'
    });
    tippy('#offer-on', {
      content: "Purchase any three products across the Vitabiotics range and get lowest priced one free.",
      maxWidth: '250px',
      trigger: 'click'
    });
    tippy('#reward-info', {
      content: "Earn reward points with every purchase and use to get money off on your next order with us.",
      maxWidth: '250px',
      trigger: 'click'
    });
    fetch('https://www.vitabiotics.com/browsing_context_suggestions.json').then(res => res.json()).then(data => {


  
      if (data.detected_values.country.handle !== "GB") {

   

        $('.purchase-type').remove();
        $('.product_offer_note').remove();
      }
    });
    $scope.currencySymbol = window.theme.currency;
    $scope.selectedItem = product.variants[0];
    $scope.selectedSellingPlan = '';
    $scope.sellingPlans = [];
    $scope.rewardPointSign = true;
    $scope.tftSign = true;
    $scope.numOfVariant = product.variants.length;
    $scope.variants = product.variants;
    $scope.qty = 1;
    $scope.subscribeBenefit = false;
    $scope.purchase = "one-time";
    $scope.productPrice = $scope.selectedItem.price / 100;
    $scope.variantSelected = $scope.selectedItem.id;
    $scope.outOfStock = $scope.selectedItem.available;
    $scope.rewardPoints =   Math.floor(($scope.selectedItem.price * llRewardPointMath) / 100);
    $scope.comparePrice = ($scope.selectedItem.compare_at_price / 100).toFixed(2);
   $scope.optionName = ($scope.selectedItem.option1 === 'Default Title') 
  ? '' 
  : $scope.selectedItem.option1;
    $scope.optionFav = $scope.selectedItem.option2;
    $scope.onetimeBenefit = true;
    $scope.selectedOption = $scope.selectedItem;
    $scope.onetimePurchasePrice = $scope.selectedItem.price / 100;
    $scope.subproductPrice = ($scope.selectedItem.price / 100) * 0.8;
    $scope.buttonTxt = "Add to Cart";

    if ($scope.selectedItem.selling_plan_allocations && $scope.selectedItem.selling_plan_allocations.length > 0) {
      function getSellingPlanName(id) {
        var result = '';
        product.selling_plan_groups[0].selling_plans.forEach((g) => {
          if (g.id == id) {
            result = g.name
          }
        });
        return result;
      }
      $scope.selectedItem.selling_plan_allocations.forEach((p) => {
        $scope.sellingPlans.push({
          plan_id: p.selling_plan_id,
          vid: $scope.selectedItem.id,
          plan_name: getSellingPlanName(p.selling_plan_id)
        });
      });
    }

    function sellingPlanDropDownUpdate() {
      if ($scope.sellingPlans.length > 1) {
        $scope.sellingPlans.forEach((p) => {
          sellingPlanRecommended.forEach((r) => {
            if (p.plan_name == r.plan && r.vid == $scope.variantSelected) {
              $scope.selectPlan = p.plan_id
            }
          });
        });

        
      }else {
         if($scope.sellingPlans[0]) {
         $scope.selectPlan = $scope.sellingPlans[0].plan_id
         }
      }
    }
    sellingPlanDropDownUpdate();
    /* change variant */

     $scope.disBadge = function() {

    var dis = Math.floor((($scope.selectedItem.compare_at_price - $scope.selectedItem.price)/$scope.selectedItem.compare_at_price) * 100);


     return $sce.trustAsHtml('<div class="triangle-badge">' + dis + '% <span class="discount_badge_off">OFF</span> </div>');
 };

    
    $scope.selectVariant = function(id) {
  
      product.variants.forEach((item) => {
        if (item.id == id) {
    
          
          $scope.selectedItem = item;
          $scope.variantSelected = item.id;
          $scope.productPrice = item.price / 100;
      
                    $scope.optionName = (item.option1 === "Default Title")?'' : item.option1;
          $scope.optionFav = item.option2;
          $scope.comparePrice = (item.compare_at_price / 100).toFixed(2);
          $scope.rewardPoints =  Math.floor(($scope.selectedItem.price * llRewardPointMath) / 100);
          $scope.outOfStock = item.available;
          $scope.onetimePurchasePrice = item.price / 100;
          $scope.subproductPrice = (item.price / 100) * 0.8;
          $scope.buttonTxt = "Add to Cart";
          $scope.subscribeBenefit = true;
          $scope.purchase = "one-time";
          $scope.onetimeBenefit = true;
          $scope.onetime = "purchase-seleted";
          $scope.subscribe = "";
          $scope.onetimeQty = $scope.qty;
          $scope.productPrice = $scope.selectedItem.price / 100;
         
          $scope.onetimePurchasePrice = $scope.selectedItem.price / 100;
          $scope.subproductPrice = ($scope.selectedItem.price / 100) * 0.8;
          $scope.sellingPlans = [];
          $scope.selectedSellingPlan = '';
          if ($scope.selectedItem.selling_plan_allocations) {
            $scope.selectedItem.selling_plan_allocations.forEach((p) => {
              $scope.sellingPlans.push({
                plan_id: p.selling_plan_id,
                vid: id,
                plan_name: getSellingPlanName(p.selling_plan_id)
              });
            });
          }
             
          sellingPlanDropDownUpdate();
          $('#onetime-purchase').click();
   
        }
      });
    }
    $scope.purchaseType = function(a) {
      if (a === 1) {
        $scope.buttonTxt = "Add to Cart";
        $scope.subscribeBenefit = false;
        $scope.purchase = "one-time";
        $scope.onetimeBenefit = true;
        $scope.onetime = "purchase-seleted";
        $scope.subscribe = "";
        $scope.onetimeQty = $scope.qty;
        $scope.comparePrice= ($scope.selectedItem.compare_at_price / 100).toFixed(2);
        document.querySelector('#onetime-purchase').click();
        $scope.productPrice = $scope.selectedItem.price / 100;
        $scope.rewardPoints =  Math.floor(($scope.selectedItem.price * llRewardPointMath) / 100);
        $scope.onetimePurchasePrice = $scope.selectedItem.price / 100;
        $scope.subproductPrice = ($scope.selectedItem.price / 100) * 0.8;
        $scope.selectedSellingPlan = '';
        return;
      }
      if ($scope.sellingPlans.length == 1) {
        $scope.selectedSellingPlan = $scope.sellingPlans[0].plan_id
      } else {
        $scope.selectedSellingPlan = $scope.selectPlan;
      }
      $scope.buttonTxt = "Subscribe";
          $scope.comparePrice= ($scope.selectedItem.compare_at_price / 100 * 0.8).toFixed(2);
      $scope.subproductPrice = ($scope.selectedItem.price / 100) * 0.8;
      $scope.productPrice = ($scope.selectedItem.price / 100) * 0.8;
      $scope.rewardPoints =  Math.floor((($scope.selectedItem.price * 0.8) * llRewardPointMath) / 100);
      $scope.subscribeBenefit = true;
      $scope.purchase = "subscribe";
      document.querySelector('#sub-purchase').click();
      $scope.onetime = "";
      $scope.subscribe = "purchase-seleted";
      $scope.onetimeBenefit = false;
      if ($scope.qty > 6) {
        $scope.qty = 6;
      }
      $scope.subQty = $scope.qty;
      return;
    }
    /*** changing plan ***/
    $scope.planChange = function() {
      $scope.selectedSellingPlan = $scope.selectPlan;
    }


    /*********************/
    $scope.notifyMe = function() {
      var id = $scope.variantSelected;
      $.ajax({
        type: 'POST',
        url: 'https://xyz.vitabiotics.com/uk/notifyme',
        data: $('#notify-me-form-' + id).serialize(),
        async: false,
        dataType: 'json',
        success: function(data) {
          const notificationSection = $('#notify-me-main-' + id);
          if (data === 1) {
            notificationSection.empty();
            notificationSection.append(
              '<p class="notification_result success">Thank you! We will notify you when we are back in stock.</p>'
            )
          } else {
            notificationSection.empty();
            notificationSection.append(
              '<p class="notification_result warning">Oops! please try agin.</p>')
          }
        }
      });
    }
    $scope.multi = function(id) {
      if (id === $scope.variantSelected) {
        return true;
      }
      return false;
    }
    $scope.selectedOption = function(id) {
      if (id == $scope.variantSelected) {
        return "optionSelected";
      }
      return "optionNotSelected";
    }
    $scope.offersection = function() {
      if ($scope.purchase == "subscribe") {
        return "offer-off";
      }
      return "offer-on";
    }
    $scope.plus = function() {
      var max = 15;
      if ($scope.purchase === "subscribe") {
        max = 6;
      }
      if ($scope.qty === max) {
        $scope.onetimeQty = max;
        return;
      }
      $scope.qty += 1;
      $scope.subQty = $scope.qty;
      $scope.onetimeQty = $scope.qty;
    }
    $scope.subtrack = function() {
      if ($scope.qty === 1) {
        $scope.subQty = $scope.onetimeQty = 1;
        return;
      }
      $scope.qty -= 1;
      $scope.subQty = $scope.qty;
      $scope.onetimeQty = $scope.qty;
    }
    $scope.subQty = 0;
    $scope.onetimeQty = 1;
    $scope.onetime = "purchase-seleted";
    $scope.addToCart = function() {
    fetch("/cart?view=custom-json")
    .then(response => response.json()) // Directly parse JSON
    .then(async (q) => { 

      var basketQty = q.item_count;
      

      if(basketQty + $scope.qty > 24) {
    alert('You can only have up to 24 items in your basket. Please adjust the quantity.');
          return;
      }else {
           if ($scope.purchase === "subscribe") {
        $scope.subQty = $scope.qty;
      } else {
        $scope.onetimeQty = $scope.qty;
      }
      document.querySelector('.product-addtocart').click();
      }

 


    });

    }
    var url = window.location.href;

    function _switchVairant(id) {
      product.variants.forEach((item) => {
        if (item.id == id) {
          $scope.selectedItem = item;
          $scope.variantSelected = item.id;
          $scope.productPrice = item.price / 100;
          $scope.optionName = (item.option1 === "Default Title")?'' : item.option1;
          $scope.optionFav = item.option2;
          $scope.rewardPoints = Math.floor((item.price * llRewardPointMath) / 100);
          $scope.outOfStock = item.available;
          $scope.onetimePurchasePrice = item.price / 100;
          $scope.subproductPrice = (item.price / 100) * 0.8;
          $scope.buttonTxt = "Add to Cart";
          $scope.subscribeBenefit = false;
          $scope.purchase = "one-time";
          $scope.onetimeBenefit = true;
          $scope.onetime = "purchase-seleted";
          $scope.subscribe = "";
          $scope.onetimeQty = $scope.qty;
          $scope.productPrice = $scope.selectedItem.price / 100;
     
          $scope.onetimePurchasePrice = $scope.selectedItem.price / 100;
          $scope.subproductPrice = ($scope.selectedItem.price / 100) * 0.8;
          $('#onetime-purchase').click();
        }
      });
    }
    if (url.includes('variant')) {
      var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
      hashes.forEach((r) => {
        var key = r.split('=');
        if (key[0] === 'variant') {
          _switchVairant(key[1])
        }
      });
    }
  }]);
  
})();
document.addEventListener('DOMContentLoaded', function() {
  $('.item__layer').attr('alt', product.title);
  var imgIcons = document.querySelectorAll('.product-features .item__icon img');
  var imgIconsTxt = document.querySelectorAll('.product-features .item__info .item__title');
  var idx = 0;
  if (imgIcons.length > 0) {
    imgIcons.forEach((i) => {
      i.setAttribute('alt', imgIconsTxt[idx].innerText);
      idx += 1;
    });
  }
});






function rewardPointCal(a,b) {
 var m = (a * b) / 100;
 return Math.floor(m);  
}
function priceCal(a) {
  var des = a - Math.floor(a, 2);
  if (des >= 0.5) {
    a = Math.ceil(a);
  } else {
    a = Math.floor(a);
  }
  return a;
}